import { docCompareChunkFinderEndpointPOST } from '~/api/def/endpoints/docCompare/docCompareChunkFinderEndpoint';
import { BaseSearchProps, ExtendedDocCompareChunkFinderChunk } from '../types';

const normalizeDocumentType = (
  doc: ExtendedDocCompareChunkFinderChunk,
): ExtendedDocCompareChunkFinderChunk => {
  if (!doc.type || doc.type.toLowerCase() === 'document') {
    return {
      ...doc,
      type: 'Documents',
    };
  }
  return doc;
};

export const searchDocuments = async ({
  searchTerm,
  onSuccess,
  onError,
  onEmpty,
}: BaseSearchProps<ExtendedDocCompareChunkFinderChunk>): Promise<void> => {
  try {
    const response = await docCompareChunkFinderEndpointPOST({
      query_text: searchTerm,
      number_of_chunks: 50,
    });

    if (response?.success === 1 && Array.isArray(response.data)) {
      const normalizedResults = response.data.map(normalizeDocumentType);

      if (normalizedResults.length === 0) {
        onEmpty?.();
      } else {
        onSuccess?.(normalizedResults);
      }
    } else {
      onEmpty?.();
    }
  } catch (error) {
    onError?.(error as Error);
  }
};
